import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MessageService } from 'src/app/services/message.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { UserApiService } from 'src/app/services/api/user-api.service';

@Component({
  selector: 'app-coupon-dialog',
  templateUrl: './coupon-dialog.component.html',
  styleUrls: ['./coupon-dialog.component.scss'],
})
export class CouponDialogComponent implements OnInit {
  code = false;

  isSmall: any;
  constructor(
    private clipboard: Clipboard,
    private message: MessageService,
    private api: UserApiService,
    private router: Router,
    private dialogRef: MatDialogRef<CouponDialogComponent>
  ) {}

  ngOnInit(): void {
    this.getSelf();
  }

  close() {
    this.dialogRef.close();
  }

  self: any = null;

  getCode() {
    this.code = true;
  }

  async getSelf() {
    try {
      const r = await this.api.getSelf();
      this.self = r.data;
    } catch (error) {}
  }

  copy() {
    this.clipboard.copy('1009');
    this.message.open('复制成功');
  }
}
